import { $, $$ } from './$.module';
import { inView } from './in-view.module';

type Options = {
  inView: Boolean;
  direction: Boolean;
}

const defaultOptions: Options = {
    inView: true,
    direction: false,
};

const settings = [];



const scrollDirection = () => {
    let lastScrollTop = -1;
    let lastDirection = -1;

    const scrollDirectionDispatcher = e => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const difference = (scrollTop - lastScrollTop);
        const direction = difference / Math.abs(difference)
        if (direction == 1) {
            document.dispatchEvent(new CustomEvent('scrolldown'));
        } else {
            document.dispatchEvent(new CustomEvent('scrollup'));
        }
        if (direction != lastDirection) {
            document.dispatchEvent(new CustomEvent('scrolldirectionchange', {detail: {direction}}));
        }
        lastScrollTop = scrollTop;
        lastDirection = direction

    }

    document.addEventListener('scroll', scrollDirectionDispatcher);
    document.addEventListener('touchmove', scrollDirectionDispatcher);
}


// const scrollAct = (selector, callback, delay = throttleDelay) => {
const scrollAct = (selector: string, callback?: Function, options?: Options) => {
    options = {
        ...defaultOptions,
        ...options
    };
    const selectors = [];

    const scrollCallback = e => {
        for (const {selector, callback} of selectors) {
            for (const el of $$(selector)) {
                if (!options.inView || inView(el)) {
                    callback(el, e)
                }
            }
        }
    }

    selectors.push({selector, callback});
    document.addEventListener('scroll', scrollCallback);
    document.addEventListener('touchmove', scrollCallback);
};

export { scrollDirection, scrollAct };
